import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-tag-manager',
	templateUrl: './tag-manager.component.html',
	styleUrls: ['./tag-manager.component.scss'],
})
export class TagManagerComponent implements OnInit {
	@Input() tags: string[] = [];
	@Input() editable: boolean = true;
	@Input() placeholder: string = 'Add a tag...';
	@Input() isError: boolean = false;
	@Input() errorMessage: string = 'Este campo es requerido';
	@Output() tagsChange = new EventEmitter<string[]>();

	tagCtrl = new FormControl('');

	ngOnInit() {
		// Emit the initial tags if provided
		this.tagsChange.emit(this.tags);
	}

	addTag(event: KeyboardEvent): void {
		if (!this.editable) {
			return;
		}

		const input = event.target as HTMLInputElement;
		const value = input.value.trim();

		if (event.key === 'Enter' && value) {
			event.preventDefault();
			if (!this.tags.includes(value)) {
				this.tags.push(value);
				this.tagsChange.emit(this.tags);
			}
			input.value = '';
		}
	}

	removeTag(tag: string): void {
		if (!this.editable) {
			return;
		}

		const index = this.tags.indexOf(tag);

		if (index >= 0) {
			this.tags.splice(index, 1);
			this.tagsChange.emit(this.tags);
		}
	}
	resetTags(): void {
		this.tags = [];
		this.tagsChange.emit(this.tags);
	}
}
